import ReactDOM from 'react-dom';
import { _process, search as newSearchService } from '../newSearch';
import { getFilterTypeHandler, getTypesHandler } from './getTypes';
import { getResultCountHandler } from './getResultCount';
import { getTopHit } from './getTopHit';
import { SEARCH_FILTERS } from 'state/Search/constants';
import { search as searchService } from '../search';

export const newSearchHandler = component => {
  return (country, isShowMoreClick) => {
    const getFilterType = getFilterTypeHandler(component);
    const getResultCount = getResultCountHandler(component);
    const {
      ampUrl,
      host,
      profileId,
      searchQuery,
      searchFilter,
      sessionId,
      currentMarket,
      abTestGroups: { webSearchOptimization1 },
    } = component.props;
    const { nextPage } = component.state.result ?? null;
    const marketId = currentMarket?.marketId ?? null;
    const { filter = SEARCH_FILTERS.ALL } = getFilterType(searchFilter);

    const { dialog } = component;
    const searchDialog = ReactDOM.findDOMNode(dialog); // eslint-disable-line

    const opts = {
      countryCode: country,
    };

    // scroll to top for new searches
    if (!isShowMoreClick && searchDialog) searchDialog.scrollTop = 0;

    return newSearchService(
      searchQuery,
      filter,
      opts,
      profileId,
      sessionId,
      ampUrl,
      host,
      marketId,
      webSearchOptimization1, // AKA searchVariant
      nextPage
    ).then(data => {
      const newState = {
        limit: component.state.limit,
        result: _process(data),
        selected: 0,
        topHit: getTopHit(data.bestMatch),
        queryId: data.queryId,
      };

      newState.resultCount = getResultCount(newState);

      return newState;
    });
  };
};

export const oldSearchHandler = component => {
  const getFilterType = getFilterTypeHandler(component);
  const getTypes = getTypesHandler(component);
  const getResultCount = getResultCountHandler(component);

  return (country, isShowMoreClick) => {
    const { offset, limit = 4 } = component.state;
    const {
      ampUrl,
      host,
      isAnonymous,
      profileId,
      searchQuery,
      searchFilter,
      sessionId,
      currentMarket,
    } = component.props;
    const marketId = currentMarket?.marketId ?? null;
    const { filter = SEARCH_FILTERS.ALL, key } = getFilterType(searchFilter);

    const { dialog } = component;
    const searchDialog = ReactDOM.findDOMNode(dialog); // eslint-disable-line

    const opts = {
      countryCode: country,
      maxRows: limit,
      startIndex: offset,
    };

    // scroll to top for new searches
    if (!isShowMoreClick && searchDialog) searchDialog.scrollTop = 0;

    // 12/30/16 Future cleanup should remove our overreliance on this process.
    // Right now it transforms the result from amp into an unrecognizable structure
    // there is almost certainly a better way to build the data structures necessary
    // if some time is invested in improving the component structure.
    //
    // SUGGESTION: right now results are passed to a master `results` key in state
    // separate out the different types of results into their own keys
    return searchService(
      searchQuery,
      filter,
      opts,
      profileId,
      sessionId,
      ampUrl,
      isAnonymous,
      host,
      marketId
    ).then(data => {
      const newState = {};
      // If we're at main search page (no filter), only show 2 results per types
      if (!key) {
        getTypes().forEach(type => {
          const results = data[type.key];
          if (!results || !results.data || !results.data.length) {
            return;
          }

          results.data = results.data.slice(0, 2);
        });
      }

      newState.limit = component.state.limit;
      newState.result = data;
      newState.selected = 0;
      newState.resultCount = getResultCount(newState);
      newState.topHit = getTopHit(data);
      return newState;
    });
  };
};
